import { render, staticRenderFns } from "./AccessControlSideMenu.vue?vue&type=template&id=42fa9a5d&"
import script from "./AccessControlSideMenu.vue?vue&type=script&lang=js&"
export * from "./AccessControlSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports